import React from 'react'

const Identity = () => {
    return (
        <div>
            <h1>Identity Page : Coming Soon....</h1>
        </div>
    )
}

export default Identity;
